import { HeaderReview } from './header-review';
import { IStepControl, Step } from '../../../domains/wizard';
import Visa from '../../../assets/images/card-visa.svg';
import Master from '../../../assets/images/card-master.svg';
import Amex from '../../../assets/images/card-amex.svg';
import { getCreditCardDots } from '../../../utils/credit-card-mask';
import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../store';

interface IProps {
  stepControl: IStepControl;
}

export const PaymentStepReview = observer((props: IProps) => {
  const { t } = useTranslation('', { keyPrefix: 'REVIEW_AND_SIGN_UP' });
  const { t: tCommon } = useTranslation('');
  const { paymentInformationStore } = useStore();
  const creditCardType = paymentInformationStore.information.creditCardType.value;
  const { paymentOption, creditCardHolderName, creditCardNumber, debitCardBankName, debitCardAccountCode } =
    paymentInformationStore.information;
  return (
    <div className="avoid-break">
      <div className="container-grey m-bottom-30">
        <HeaderReview stepControl={props.stepControl} step={Step.Payment} />

        <div className="container-readonly" id="div_payment_options_conf">
          <label>{t('PAYMENT_OPTION')}</label>
          <span>{tCommon(`PAYMENT_INFORMATION.${paymentOption.value.replaceAll(' ', '_').toUpperCase()}`)}</span>
        </div>

        {paymentOption.value === 'Credit Card' && (
          <div className="container-card-info-conf">
            {creditCardType === 'VISA' && <img src={Visa} alt={''} />}
            {creditCardType === 'MASTER' && <img src={Master} alt={''} />}
            {creditCardType === 'AMEX' && <img src={Amex} alt={''} />}
            <div className="d-flex container-card-number-conf">
              <div className="d-flex container-dot-groups">
                {getCreditCardDots(creditCardType)}
                <span className={'card-dot-group'}>{creditCardNumber.value.slice(-4)}</span>
              </div>
            </div>

            <div className="container-readonly">
              <label>{tCommon('PAYMENT_INFORMATION.CARD_HOLDER_NAME')}</label>
              <span>{creditCardHolderName.value}</span>
            </div>
          </div>
        )}

        {paymentOption.value === 'Debit' && (
          <div>
            <div className="container-readonly">
              <label>{tCommon('PAYMENT_INFORMATION.BANK_NAME')}</label>
              <span>{debitCardBankName.value}</span>
            </div>
            <div className="container-readonly">
              <label>{tCommon('PAYMENT_INFORMATION.ACCOUNT_CODE')}</label>
              <span>{debitCardAccountCode.value}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});
